import { Injectable } from '@angular/core'
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http'
import { Observable, throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { environment } from 'src/environments/environment'

@Injectable({ providedIn: 'root' })
export class GlobalHttpInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const headers: any = {}

    if (localStorage.getItem('lang'))
      headers['accept-language'] = localStorage.getItem('lang')

    const updatedRequest = request.clone({
      setHeaders: headers,
      // Auth now travels in the HttpOnly cookie issued at login; send it with every API call.
      withCredentials: true,
      url: request.url.includes('/assets/i18n/')
        ? `${request.url}`
        : environment.api_url + `/${request.url}`
    })
    return next.handle(updatedRequest).pipe(
      catchError((err: HttpErrorResponse) => {
        // throw error to the console
        return throwError(err)
      })
    )
  }
}
